import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입 (shoebill.ts에서 가져온 raw DTO)
type MarketProductsResponse =
  OAISchema['CursorPagedResponseMarketSelectProductResponseV2'];

export type MarketProductsParams = {
  vendorId?: number;
  categoryIds?: number[];
  displayCategoryIds?: Array<number | string>;
  productType?: string;
  deliveryType?: string;
  salesTarget?: string;
  salesTargets?: string[];
  sortType?: string;
  size?: number;
  searchAfter?: string[];
  [key: string]: unknown;
};

export interface MarketProductsDataSource {
  // Query
  getMarketProducts(
    params: MarketProductsParams,
  ): Promise<MarketProductsResponse>;
  getMarketProductsCount(params: MarketProductsParams): Promise<number>;
}

export class MarketProductsDataSourceImpl implements MarketProductsDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getMarketProducts(params: MarketProductsParams) {
    return this.client.request<MarketProductsResponse>({
      url: '/api/market-place/v3/products',
      method: 'get',
      params: { ...params },
    });
  }

  async getMarketProductsCount(params: MarketProductsParams) {
    return this.client.request<number>({
      url: '/api/market-place/v3/products/count',
      method: 'get',
      params: { ...params },
    });
  }
}

export const marketProductsDataSource = new MarketProductsDataSourceImpl();
